import { F, T } from "../../theme/tokens";

// ── Page header ───────────────────────────────────────────────────────────────

// `stackOnPhone` is for a wide group of controls (a period filter): on a phone it drops
// below the title instead of squeezing the title into a sliver beside it.
export function PageHeader({ title, sub, actions, stackOnPhone }: { title: string; sub?: string; actions?: React.ReactNode; stackOnPhone?: boolean }) {
  return (
    <div className={stackOnPhone ? "page-header page-header--stack" : "page-header"} style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "28px", flexWrap: "wrap", gap: "12px" }}>
      <div>
        <h1 style={{ fontSize: "20px", fontWeight: 700, color: T.text, fontFamily: F, letterSpacing: "-0.02em", margin: 0 }}>{title}</h1>
        {sub && <p style={{ fontSize: "12px", color: T.sub, fontFamily: F, marginTop: "3px" }}>{sub}</p>}
      </div>
      {actions && <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>{actions}</div>}
    </div>
  );
}
